<style lang="scss" scoped>
#change-password {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  font-family: "Manrope";
  flex-direction: column;
  font-weight: 500;
}
.form {
  min-width: 300px;
  border: 1px solid rgb(219, 219, 219);
  padding: 45px 40px;
  border-radius: 7px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;
}
</style>
<template>
  <div id="change-password">
    <b-row class="form">
      <b-col>
        <div class="text-24 text-bold text-left">Ubah Password</div>
        <div class="text-14 text-550 text-semi-bold">
          Password baru Anda harus berbeda dengan password <br />
          yang Anda gunakan sebelumnya.
        </div>
        <ValidationObserver v-slot="{ validate }">
          <form class="mt-5" @submit.prevent="validate">
            <ValidationProvider
              v-if="isPmse"
              name="Password lama"
              :rules="'required'"
              v-slot="{ errors }"
              vid="oldPassword"
            >
              <b-form-group label="Password lama">
                <b-form-input
                  :type="showPassword ? 'text' : 'password'"
                  v-model="oldPassword"
                  placeholder="* * * * * * * * *"
                  :state="errors[0] ? false : oldPassword ? true : null"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="false">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
            <ValidationProvider
              name="Password baru"
              :rules="isPmse ? 'required|min:6|custompassword' : 'required|min:6'"
              v-slot="{ errors }"
              vid="passwordConfirmation"
            >
              <b-form-group label="Password baru">
                <b-form-input
                  :type="showPassword ? 'text' : 'password'"
                  v-model="password"
                  placeholder="* * * * * * * * *"
                  :state="errors[0] ? false : password ? true : null"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="false">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
            <ValidationProvider
              name="Konfirmasi password baru"
              rules="required|confirmed:passwordConfirmation"
              v-slot="{ errors }"
            >
              <b-form-group label="Konfirmasi password baru">
                <b-form-input
                  :type="showPassword ? 'text' : 'password'"
                  v-model="confirmPassword"
                  placeholder="* * * * * * * * *"
                  :state="errors[0] ? false : confirmPassword ? true : null"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="false">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <b-form-checkbox
              v-model="showPassword"
              style="line-height: 1.8; margin-top: -10px"
              >Tampilkan password</b-form-checkbox
            >

            <b-button
              class="w-100 button button--primary mt-3"
              type="submit"
              v-on:click="
                () => {
                  validate().then((result) => {
                    if (result) {
                      changePassword();
                    }
                  });
                }
              "
              >Ubah Password
            </b-button>
            <b-button class="button mt-2 w-100" v-on:click="$router.back()">
              <VueFeather
                type="arrow-left"
                size="14"
                stroke-width="1"
              ></VueFeather>
              &nbsp;Kembali
            </b-button>
          </form>
        </ValidationObserver>
      </b-col>
    </b-row>

    <b-toast
      id="toast"
      variant="danger"
      solid
      body-class="text-manrope text-medium w-100"
      no-close-button
      toaster="b-toaster-top-center"
      class="w-100"
    >
      <template #toast-title>
        <div
          class="d-flex flex-grow-1 align-items-center text-manrope text-semi-bold text-nowrap"
        >
          <b-img
            blank
            blank-color="#e32929"
            class="mr-2"
            width="10"
            height="10"
          ></b-img>
          <strong class="mr-auto">{{ toast.title }}!</strong>
        </div>
      </template>
      {{ toast.message }}
    </b-toast>

    <b-modal
      id="access-server"
      size="sm"
      hide-header
      hide-footer
      content-class="text-center py-3 px-3"
      centered
      dialog-class="d-flex justify-content-center"
    >
      <div v-if="modal.accessServer.isLoading">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight: 600; font-size: 16px; color: #01ad85">
            Mohon tunggu sebentar
          </div>
          <div style="font-weight: 500; font-size: 13px; color: #0a4e5c">
            {{ modal.accessServer.loadingMessage }}
          </div>
        </div>
      </div>

      <div v-else>
        <div
          v-if="modal.accessServer.isError"
          class="text-center py-2"
          style="color: red"
        >
          <div>
            <VueFeather type="x-circle" size="40" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight: 600; font-size: 17px; color: red">
            {{ modal.accessServer.errorTitle }}
          </div>
          <div class="text-700 text-13">
            {{ modal.accessServer.errorMessage }}
          </div>
          <div class="mt-3 d-flex justify-content-center">
            <b-button
              class="button button--warning"
              v-on:click="
                () => {
                  $bvModal.hide('access-server');
                }
              "
              >Ok</b-button
            >
          </div>
        </div>
        <div v-else>
          <div class="text-center py-3">
            <img src="@/assets/img/success.gif" width="100" height="100" />
            <div style="font-weight: 600; font-size: 16px; color: #01ad85">
              Berhasil menyimpan
            </div>
            <div style="font-weight: 500; font-size: 13px; color: #0a4e5c">
              Anda akan di <i>redirect</i> ke halaman Login dalam beberapa detik
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueFeather from "vue-feather";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import UserService from "@/services/UserService";
import PmseService from "@/services/PmseService";
export default {
  components: {
    VueFeather,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      oldPassword: null,
      password: null,
      confirmPassword: null,
      showPassword: false,
      toast: {
        title: null,
        message: null,
        time: null,
      },
      modal: {
        accessServer: {
          isLoading: false,
          loadingMessage: null,
          isError: false,
          errorTitle: null,
          errorMessage: null,
        },
      },
    };
  },
  methods: {
    changePassword() {
      this.$bvModal.show("access-server");
      this.modal.accessServer.isLoading = true;
      this.isPmse
        ? PmseService.changePasswordAuth({
            password: this.password,
            oldPassword: this.oldPassword,
            passwordConfirmation: this.confirmPassword,
          })
            .then(() => {
              this.modal.accessServer.isLoading = false;
              this.modal.accessServer.isError = false;
              new Promise((resolve) => setTimeout(resolve, 1200)).then(() =>
                this.$router.push("/logout-pmse")
              );
            })
            .catch((error) => {
              console.log(error);
              this.modal.accessServer.isLoading = false;
              this.modal.accessServer.isError = true;
              this.modal.accessServer.errorTitle =
                (error.response && error.response.data && error.response.data.error) ||
                "Gagal";
              this.modal.accessServer.errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                "Terjadi kesalahan saat mengubah password";
            })
        : UserService.changeUserPassword(this.password)
            .then(() => {
              this.modal.accessServer.isLoading = false;
              this.modal.accessServer.isError = false;
              new Promise((resolve) => setTimeout(resolve, 1200)).then(() =>
                this.$router.push("/logout")
              );
            })
            .catch((error) => {
              console.log(error);
              this.modal.accessServer.isLoading = false;
              this.modal.accessServer.isError = true;
              this.modal.accessServer.errorTitle =
                (error.response && error.response.data && error.response.data.error) ||
                "Gagal";
              this.modal.accessServer.errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                "Terjadi kesalahan saat mengubah password";
            });
    },
  },
  computed: {
    isPmse: function () {
      return this.$route.name === 'ChangePasswordPmse'
    },
  },
};
</script>
